export default "__VITE_ASSET__6014701f__"